import { styled } from '@mui/system'
import { colors, fontSizes } from '../../consts'

type SelectorProps = {
  size?: 'sm' | 'md' | 'lg'
  color?: string
  textColor?: string
}

export const SelectorStyle = styled('div')<SelectorProps>(
  ({ size, color, textColor, theme }) => ({
    margin: theme.spacing(2, 1),
    '& > .MuiInputBase-root': {
      fontSize:
        size === 'lg'
          ? fontSizes.semiLarge
          : size === 'md'
          ? fontSizes.medium
          : fontSizes.small,
      fontWeight: 'bold',
      [theme.breakpoints.down('md')]: {
        fontWeight: 600,
        fontSize:
          size === 'lg'
            ? fontSizes.medium
            : size === 'md'
            ? fontSizes.small
            : fontSizes.xSmall,
        color: textColor ? textColor : colors.text,
      },
      '& .MuiInput-underline:before': { borderBottomColor: colors.lightestGrey },
    '& .MuiInput-underline:after': { borderBottomColor: colors.lightestGrey },
      '&::before': {
        display: 'none',
      },
      '&::after': {
        display: 'none',
      },
      '& svg': {
        fill: color,
      },
    },
  })
)

export const SeasonRowStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  margin: theme.spacing(0, 2),
}))

export const SelectorCon = styled('div')(({ theme }) => ({
  margin: theme.spacing(1, 2),
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',

  [theme.breakpoints.down('xs')]: {
    justifyContent: 'center',
  },

  '& > div:first-of-type': {
    borderRadius: 18,
  },
}))

type SeasonTypeProps = {
  active: boolean
  disabled?: boolean
}
export const SeasonTypeItemCon = styled('div')<SeasonTypeProps>(
  ({ active, disabled = false, theme }) => ({
    display: disabled ? 'none' : 'block',
    fontSize: fontSizes.small,
    fontWeight: active ? 800 : 400,
    margin: theme.spacing(0.5, 2),
    cursor: 'pointer',
  })
)

export const SelectorOutlinedStyle = styled('div')<SelectorProps>(
  ({ color, theme }) => ({
    fontSize: fontSizes.medium,
    color: color || colors.text,
    fontWeight: 'normal',
    borderRadius: 8,
    padding: theme.spacing(0, 3),
    height: 40,
    minWidth: 200,
    margin: theme.spacing(0, 0.5),
    '&::before': {
      display: 'none',
    },
    '&::after': {
      display: 'none',
    },
  })
)

type SelectContainerProps = {
  size?: 'sm' | 'md' | 'lg'
  color?: string
  textColor?: string
}

export const SelectContainer = styled('div')<SelectContainerProps>(
  ({ size, color, textColor, theme }) => ({
    position: 'relative',
    '& label': {
      display: 'block',
      fontSize: size === 'sm' ? fontSizes.small : fontSizes.medium,
      fontWeight: 500,
      marginBottom: theme.spacing(1),
      color: textColor || color || colors.text,
    },
    marginRight: theme.spacing(2),
  })
)

type SelectButtonProps = {
  fontSize: number | typeof fontSizes
  bold: boolean
}

export const SelectButton = styled('button')<SelectButtonProps>(({ theme, fontSize, bold }) => ({
  padding: theme.spacing(1, 2),
  textAlign: 'left',
  backgroundColor: 'white',
  cursor: 'pointer',
  minHeight: 40,
  minWidth: theme.spacing(2),
  border: 'none',
  appearance: 'none',
  background: 'none',
  paddingRight: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  whiteSpace: 'nowrap',
  '& .select-value': {
    flex: 1,
    textAlign: 'left',
    fontSize: fontSize,
    fontWeight: bold ? 600 : 400,
  },
}))

export const OptionsList = styled('ul')(({ theme }) => ({
  position: 'absolute',
  marginTop: theme.spacing(0.5),
  backgroundColor: 'white',
  borderRadius: 2,
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
  maxHeight: 240,
  overflowY: 'auto',
  listStyle: 'none',
  padding: 0,
  zIndex: 99999,
}))

type OptionItemProps = {
  isSelected?: boolean
  fontSize: number | typeof fontSizes
}

export const OptionItem = styled('li')<OptionItemProps>(
  ({ isSelected, theme, fontSize }) => ({
    padding: theme.spacing(1, 2),
    cursor: 'pointer',
    // @ts-ignore
    fontSize: typeof fontSize === 'number' ? fontSize : fontSizes[fontSize],
    backgroundColor: isSelected ? `${colors.blue}20` : 'transparent',
    '&:hover': {
      backgroundColor: `${colors.gray.gray80}20`,
    },
  })
)